import styled from 'styled-components';

import {
  Modal as SemanticModal,
} from 'semantic-ui-react';

const Modal = styled(SemanticModal)`
    &.ui.modal {
    width: 450px;
  }
`;

const Container = styled.div`
  text-align: center;
  font-size: 16px;
  padding: 35px;
  border-radius: 5px;
`;

const Link = styled.a`
  color: #477ae9;
`;

const Span = styled.p`
  color: black;
  font-weight: 400;
  margin-bottom: 30px;
`;

export {
  Modal,
  Container,
  Link,
  Span,
};
